var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.94403,
    width: 8.71077,
    height: 8.71077,
    rx: 4.35539,
    stroke: "#B7844D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2598 15.6294L12.3214 11.6909",
    stroke: "#B7844D",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86474 8.21811L5.61255 8.4752L7.23906 10.1215H7.43071L10.6837 6.84869L10.387 6.57385L7.79431 9.2381L7.31381 9.66434L5.86474 8.21811Z",
    fill: "#B7844D",
    stroke: "#B7844D",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0201 12.0105V1.00494H1.58008V17.0464H15.0201V16.1126",
    stroke: "#B7844D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryReview);
export default __webpack_public_path__ + "static/media/EntryReview.125128ca3d6a76059a65900e13d225c8.svg";
export { ForwardRef as ReactComponent };